import { WweFolders, WweRcs } from '../enums/wwe-rcs.enum';

export class DataServiceApiUtil {
	public static createPacRcsPath(rcs: WweRcs): string {
		return DataServiceApiUtil.createRcsPath(WweFolders.PAC, rcs);
	}

	public static createPcRcsPath(rcs: WweRcs): string {
		return DataServiceApiUtil.createRcsPath(WweFolders.PC, rcs);
	}

	public static createAcRcsPath(rcs: WweRcs): string {
		return DataServiceApiUtil.createRcsPath(WweFolders.AC, rcs);
	}

	private static createRcsPath(directory: WweFolders, rcs: WweRcs): string {
		return directory + ':' + rcs;
	}
}
